import React, { useState, useEffect, cloneElement } from 'react'
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  FunctionField,
  TextInput,
  Edit,
  EditButton,
  required,
  useNotify,
  useInput,
  useRedirect,
  ReferenceInput,
  SelectInput,
  EmailField,
  ReferenceField,
  CreateButton,
  useListContext,
  TopToolbar,
  sanitizeListRestProps,
  Button,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import ReactJson from 'react-json-view'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-textmate'
import { CustomToolbar } from './CustomToolbar'
import ExportButton from '../shared-components/export-button'

const ListActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props
  const { resource, displayedFilters, filterValues, basePath, showFilter } = useListContext()
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
      <ExportButton filter={filterValues} resourceType="SOCIAL-MEDIA" />
    </TopToolbar>
  )
}

export const SocialMediaList = (props) => (
  <List {...props} actions={<ListActions />}>
    <Datagrid>
      <ReferenceField label="Organization" source="organization_id" reference="organizations">
        <EmailField source="api_username" />
      </ReferenceField>
      <TextField source="slug" />
      <TextField source="type" />
      <FunctionField
        label="Configuration"
        render={(record) => (
          <div>
            <label>
              <ReactJson
                src={record.configuration}
                name={false}
                shouldCollapse={() => {}}
                enableClipboard={false}
                displayDataTypes={false}
                displayObjectSize={false}
              />
            </label>
          </div>
        )}
      />
      <EditButton />
    </Datagrid>
  </List>
)

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flexGrow: 1,
  },
  input: {
    marginBottom: '-20px',
  },
  text: {
    color: '#0000008A',
  },
}))

const ConfigInput = (props) => {
  const [configValue, setConfigValue] = useState('')
  const [isChanged, setIsChanged] = useState(false)
  const config = useInput(props)

  useEffect(() => {
    setConfigValue(JSON.stringify(config.input.value, null, '\t'))
    setIsChanged(false)
  }, [config.input.value])

  function onChange(newValue) {
    setConfigValue(newValue)
    setIsChanged(true)
  }

  function saveToForm() {
    const parsed = JSON.parse(configValue)
    config.input.onChange(parsed)
  }

  return (
    <>
      <AceEditor
        name="configuration"
        style={{ height: '200px', width: '100%' }}
        mode="json"
        theme="textmate"
        onChange={onChange}
        value={configValue}
      />
      {isChanged && (
        <Button variant="contained" size="small" color="primary" onClick={saveToForm}>
          <>Commit Changes</>
        </Button>
      )}
    </>
  )
}

export const SocialMediaCreate = (props) => {
  const classes = useStyles()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created', 'info', { smart_count: 1 })
    redirect('/social_media')
  }

  return (
    <Create {...props} onSuccess={onSuccess}>
      <SimpleForm>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                className={classes.input}
                source="slug"
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                className={classes.input}
                source="type"
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={6}>
              <ReferenceInput
                className={classes.input}
                fullWidth
                label="Organization"
                source="organization_id"
                reference="organizations"
                validate={[required()]}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <p className={classes.text}>Configuration</p>
              <ConfigInput source="configuration" label="configuration" />
            </Grid>
          </Grid>
        </div>
      </SimpleForm>
    </Create>
  )
}

const EditTitle = ({ record }) => {
  return <span>{record ? `"${record.slug}"` : ''} Edit</span>
}

export const SocialMediaEdit = (props) => {
  const classes = useStyles()
  return (
    <Edit {...props} title={<EditTitle />}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextInput fullWidth source="id" disabled className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                className={classes.input}
                source="slug"
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                className={classes.input}
                source="type"
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={6}>
              <ReferenceInput
                className={classes.input}
                fullWidth
                label="Organization"
                source="organization_id"
                reference="organizations"
                validate={[required()]}
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <p className={classes.text}>Configuration</p>
              <ConfigInput source="configuration" label="configuration" />
            </Grid>
          </Grid>
        </div>
      </SimpleForm>
    </Edit>
  )
}
